import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Button,
} from "reactstrap";
import SelectCoursesAndModules from "./SelectCoursesAndModules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

export default function AddLinkModal(props) {
  const [linkSelected, setLinkSelected] = useState(false);
  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [linkToUpload, setLinkToUpload] = useState(null);
  const [invalidLink, setInvalidLink] = useState(false);

  let handleCheckModules = (event, id) => {
    if (event.target.checked && !selectedModules.includes(id)) {
      setSelectedModules([...selectedModules, id]);
    } else if (!event.target.checked && selectedModules.includes(id)) {
      setSelectedModules([
        ...selectedModules.filter(function (mid) {
          return mid !== id;
        }),
      ]);
    }
  };

  let handleCheckCourses = (event, id) => {
    if (event.target.checked) {
      setSelectedCourse(id);
    } else {
      setSelectedCourse(null);
      setSelectedModules([]);
    }
  };

  function validateURL(textval) {
    var urlregex = new RegExp(
      "^(http|https|ftp)://([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&amp;%$-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9-]+.)*[a-zA-Z0-9-]+.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(/($|[a-zA-Z0-9.,?'\\+&amp;%$#=~_-]+))*$"
    );
    return urlregex.test(textval);
  }

  let checkLink = (event) => {
    if (validateURL(event.target.value)) {
      setInvalidLink(false);
      setLinkToUpload(event.target.value);
    } else {
      setInvalidLink(true);
    }
  };

  let checkAndSetLink = () => {
    if (!invalidLink) {
      setLinkSelected(true);
    }
  };

  let toggleModal = () => {
    setLinkSelected(false);
    setSelectedCourse(null);
    setSelectedModules([]);
    setInvalidLink(false);
    setLinkToUpload(null);
    props.toggleLinkModal();
  };

  let handleuppload = () => {
    let selection = { courses: [], modules: [] };
    selection.courses = selectedCourse;
    selection.modules = selectedModules;
    props.handleUploadLink(selection, linkToUpload);
    toggleModal();
  };

  return (
    <Modal isOpen={props.linkModalOpen} toggle={props.toggleLinkModal}>
      <ModalHeader toggle={props.toggleLinkModal}>
        <FormattedMessage id="CreateLink" />
      </ModalHeader>
      <ModalBody>
        {!linkSelected ? (
          <>
            <FormattedMessage id="WriteLinkAndContinue" />
            <Input
              onChange={(event) => checkLink(event)}
              placeholder="https://www.google.se"
            />{" "}
            {invalidLink ? (
              <span className="ms-2 text-danger">
                <FontAwesomeIcon icon="exclamation" className="me-1" />{" "}
                <FormattedMessage id="WrongUrlFormat" />
              </span>
            ) : (
              ""
            )}
          </>
        ) : (
          <SelectCoursesAndModules
            courses={props.courses}
            handleCheckCourses={handleCheckCourses}
            handleCheckModules={handleCheckModules}
            selectedModules={selectedModules}
            selectedCourse={selectedCourse}
          />
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" outline onClick={toggleModal}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          color="primary"
          outline
          disabled={invalidLink || linkToUpload === null}
          onClick={!linkSelected ? checkAndSetLink : handleuppload}
        >
          {!linkSelected ? (
            <FormattedMessage id="Continue" />
          ) : (
            <FormattedMessage id="AddLink" />
          )}
        </Button>{" "}
      </ModalFooter>
    </Modal>
  );
}
